import { useCallback, useRef } from 'react';

import isEqual from 'fast-deep-equal';

import { Noop } from '@hsp/utilities';

import { ICagingCalendarContext } from '@p/a/r/calendar/context/types/context.type';
import { CagingCalendarContextReturnType } from '@p/a/r/calendar/context/types/context-return.type';

export const useCagingCalendarStore = (): CagingCalendarContextReturnType => {
  const store = useRef<ICagingCalendarContext>({
    selectedDays: [],
    selectedMonths: [],
    selectedQuarters: [],
    selectedWeeks: [],
  });

  const subscribers = useRef<Set<Noop>>(new Set());

  const get = useCallback(() => store.current, []);
  const set = useCallback((value: Partial<ICagingCalendarContext>) => {
    const updated = { ...store.current, ...value };

    if (isEqual(store.current, updated)) {
      return;
    }

    store.current = updated;
    subscribers.current.forEach((callback) => callback());
  }, []);
  const subscribe = useCallback((callback: Noop) => {
    subscribers.current.add(callback);

    return () => {
      subscribers.current.delete(callback);
    };
  }, []);

  return {
    get,
    set,
    subscribe,
  };
};
